import { render, staticRenderFns } from "./AssessmentSurveyPanel.vue?vue&type=template&id=54a19d56&scoped=true&"
import script from "./AssessmentSurveyPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentSurveyPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSurveyPanel.vue?vue&type=style&index=0&id=54a19d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a19d56",
  null
  
)

export default component.exports